<app-mathia-generic-search-filter
    [definitions]="definitions"
    [initialSelection]="initialSelection"
    [filterConfig]="filterConfig"
    [facetScope]="facetScope"
    [resultCount]="resultCount"
    (selectionChange)="selectionChange.emit($event)">
</app-mathia-generic-search-filter>

